import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { IExplorer } from '@/types/explorer';
import { getMainExplorerData } from '@/api/explorer';

const REFRESH_INTERVAL = 180000; // 3 minutes

export default function useExplorerData() {
  const [data, setData] = useState<IExplorer | undefined>();
  const { data: updatedData, error } = useSWR(
    '/explorer',
    getMainExplorerData,
    { refreshInterval: REFRESH_INTERVAL },
  );

  useEffect(() => {
    if (updatedData && !error) {
      setData(updatedData);
    }
  }, [updatedData, error]);

  return {
    data,
    isLoading: !error && !data,
    isError: error,
  };
}
